/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MillingElement } from '../../models/milling-element';
import { UpdateMillingElementDto } from '../../models/update-milling-element-dto';

export interface UpdateOneBaseMgmtMillingElementControllerMillingElement$Params {
  id: number;
      body: UpdateMillingElementDto
}

export function updateOneBaseMgmtMillingElementControllerMillingElement(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<StrictHttpResponse<MillingElement>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtMillingElementControllerMillingElement.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MillingElement>;
    })
  );
}

updateOneBaseMgmtMillingElementControllerMillingElement.PATH = '/api/mgmt/milling-element/{id}';
